import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Nav } from "reactstrap";

import Home from "../Home/index";
import Fishfarm from "../Fishfarm/index";
import Associates from "../Associates/index";
import Poultory from "../PoultoryFarm/index";
import Hotels from "../Hotels/index";
import Cart from "../Cart";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/home" exact component={Home} />
        <Route path="/fishfarm" component={Fishfarm} />
        <Route path="/associates" component={Associates} />
        <Route path="/poultory" component={Poultory} />
        <Route path="/hotels" component={Hotels} />
        <Route path="/cart" component={Cart} />
        <Redirect to="/home" />
      </Switch>
    </BrowserRouter>
  );
};

export default Navigation;
